import { companyTaskPath, projectTaskPath, shellNavUrl, taskCommentAnchor } from "@/lib/task-board"

export type TaskLinkTarget = { project_id: number; key: string; company_slug: string }

export function taskOpenUrl(currentUrl: string, target: TaskLinkTarget, commentId: number | null = null): string {
  const hash = commentId == null ? "" : `#${taskCommentAnchor(commentId)}`
  const url = shellNavUrl(currentUrl)
  const cut = url.indexOf("?")
  const path = cut < 0 ? url : url.slice(0, cut)
  const params = new URLSearchParams(cut < 0 ? "" : url.slice(cut + 1))
  if (path === "/company/tasks") {
    const projectId = params.get("project_id")
    if (projectId != null && projectId !== String(target.project_id)) params.delete("project_id")
    const search = params.toString()
    return `${companyTaskPath(target.company_slug, target.key)}${search ? `?${search}` : ""}${hash}`
  }
  const search = path === `/projects/${target.project_id}/workspace/tasks` ? params.toString() : ""
  return `${projectTaskPath(target)}${search ? `?${search}` : ""}${hash}`
}
